<template>

    <transition name="fade" mode="out-in" v-if="this.$store.getters.getterModalState">
        <div class="modal lightbox">

            <div class="modal-inner">
                <a class="modal-close" href="#" @click.prevent="closeModal" :class="{'special' : type == 'video'}">

                    <svg xmlns="http://www.w3.org/2000/svg" width="15.556" height="15.556" viewBox="0 0 15.556 15.556"><g id="Symbol_85_1" data-name="Symbol 85 – 1" transform="translate(-1064 -310)"><path id="Union_3" data-name="Union 3" d="M7.778,9.192,1.414,15.557,0,14.142,6.364,7.778,0,1.414,1.414,0,7.778,6.364,14.142,0l1.415,1.414L9.192,7.778l6.364,6.364-1.415,1.415Z" transform="translate(1064 310)" fill="#333"/></g></svg>
                </a>

                <template v-if="type == 'gallery'">
                    <swiper :options="swiperSlider" class="gallery" ref="swiper">
                        <swiper-slide v-for="(item, index) in images" :key="index" class="gallery-item">
                            <img alt="" :key="index" :src="publicPath+item">
                        </swiper-slide>
                    </swiper>

                    <div class="gallery-nav-wrapper">

                        <div class="gallery-nav left" @click="prev">

                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><g id="Group_203" data-name="Group 203" transform="translate(-1431 -507)"><g id="Backward_Arrow" data-name="Backward Arrow" transform="translate(1441 517) rotate(180)"><path id="Path_10" data-name="Path 10" d="M5,0,4.091.909,7.532,4.351H0v1.3H7.532L4.091,9.091,5,10l5-5Z" fill="#D60E33"/></g></g></svg>

                        </div>

                        <div class="gallery-nav right" @click="next">

                            <svg id="Backward_Arrow" data-name="Backward Arrow" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path id="Path_10" data-name="Path 10" d="M5,0,4.091.909,7.532,4.351H0v1.3H7.532L4.091,9.091,5,10l5-5Z" fill="#D60E33"/></svg>

                        </div>
                    </div>
                </template>

                <template v-else>
                    <div class="modal-video">
                        <iframe v-if="videoType == 'youtube'" width="100%" height="100%" :src="'https://www.youtube.com/embed/'+videoUrl+'?modestbranding=1&autoplay=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                        <iframe v-else :src="'https://player.vimeo.com/video/'+videoUrl+'?autoplay=1'" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                    </div>
                </template>

            </div>

        </div>
    </transition>

</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'Modal',
  components: {
    Swiper,
    SwiperSlide,
  },

  data () {
    return {
      images: '',
      videoUrl: '',
      videoType: 'youtube',
      publicPath: process.env.BASE_URL,
      type: "",
      swiperSlider: {
        autoResize: false,
        spaceBetween: 30,
        centeredSlides: false,
        loop: true,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        pagination: {
          el: '.gallery-pagination',
          renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span><span class="sepparator">|</span><span class="sum ' + totalClass + '"></span>';
          }
        },
        breakpoints: {
          768: {
            spaceBetween: 30,
          }
        }
      },
    }
  },
  methods: {
    modalState (modalData, modalType) {
      if (modalType == 'gallery') {
        this.images = modalData
      }
      else {
        this.videoUrl = Object.values(modalData)[0].video
        this.videoType = Object.values(modalData)[0].vimeo ? 'vimeo' : 'youtube'
      }
      this.$store.dispatch('updateModalState', true)
      this.type = modalType
    },
    prev() {
      this.$refs.swiper.$swiper.slidePrev()
    },
    next() {
      this.$refs.swiper.$swiper.slideNext()
    },
    closeModal () {
      this.$emit('unlock-body')
      this.$store.dispatch('updateModalState', false)
    }
  }
}
</script>

